import React, { useState } from 'react';
import styles from './Destination.module.css';
import Navbar from './Navbar';
// import data from './data.json'; // Assuming the JSON file is saved as data.json
import Moon from './destination/image-moon.jpg'; // Assuming the image is saved in the destination folder
import Europa from './destination/image-europa.jpg'; // Assuming the image is saved in the destination folder
import Mars from './destination/image-mars.jpg'; // Assuming the image is saved in the destination folder
import Titan from './destination/image-titan.jpg'; // Assuming the image is saved in the destination folder
const Destination = () => {
    const [selectedDestination, setSelectedDestination] = useState(0); // Default to the first destination
 const destination = [
    {
        "name": "Moon",
       
          "image": Moon,
        "description": "See our planet as you’ve never seen it before. A perfect relaxing trip away to help regain perspective and come back refreshed. While you’re there, take in some history by visiting the Luna 2 and Apollo 11 landing sites.",
        "distance": "384,400 km",
        "travel": "3 days"
      },
      {
        "name": "Mars",
      
          "image": Mars,
     
        "description": "Don’t forget to pack your hiking boots. You’ll need them to tackle Olympus Mons, the tallest planetary mountain in our solar system. It’s two and a half times the size of Everest!",
        "distance": "225 mil. km",
        "travel": "9 months"
      },
      {
        "name": "Europa",
     
          "image": Europa,
       
        "description": "The smallest of the four Galilean moons orbiting Jupiter, Europa is a winter lover’s dream. With an icy surface, it’s perfect for a bit of ice skating, curling, hockey, or simple relaxation in your snug wintery cabin.",
        "distance": "628 mil. km",
        "travel": "3 years"
      },
      {
        "name": "Titan",
      
          "image": Titan,
             
        "description": "The only moon known to have a dense atmosphere other than Earth, Titan is a home away from home (just a few hundred degrees colder!). As a bonus, you get striking views of the Rings of Saturn.",
        "distance": "1.6 bil. km",
        "travel": "7 years"
      }
 ]
    return (
        <div className={styles.Destination}>
            {/* Navbar */}
            <Navbar />

            {/* Main Content */}
            <main className={styles.mainDestination}>
                <h1>
                    <span>01</span> PICK YOUR DESTINATION
                </h1>

                {/* Destination Details */}
                <div className={styles.destinationDetails}>
                    {/* Destination Image */}
                    <div className={styles.destinationImg}>
                        <img
                            src={destination[selectedDestination].image}
                            alt={destination[selectedDestination].name}
                            className={styles.destinationImage}
                        />
                    </div>

                    {/* Destination Info */}
                    <div className={styles.destinationInfo}>
                        {/* Tabs for Destination Names */}
                        <div className={styles.tabs}>
    {destination.map((destination, index) => (
        <button
            key={destination.name}
            className={index === selectedDestination ? styles.activeTab : styles.tab}
            onClick={() => setSelectedDestination(index)}
        >
            {destination.name}
        </button>
    ))}
</div>

                        {/* Destination Details */}
                        <h2>{destination[selectedDestination].name}</h2>
                        <p className={styles.description}>{destination[selectedDestination].description}</p>

                        {/* Additional Information */}
                        <div className={styles.additionalInfo}>
                            <div className={styles.infoBlock}>
                                <h3>AVG. DISTANCE</h3>
                                <p>{destination[selectedDestination].distance}</p>
                            </div>
                            <div className={styles.infoBlock}>
                                <h3>EST. TRAVEL TIME</h3>
                                <p>{destination[selectedDestination].travel}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default Destination;
